import React from "react";
import { TextField } from "@material-ui/core";
import Label from "./LabelF";
import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles({
  likeComponent: {
    "& .MuiInputBase-input": {
      //  height: "1.4375em",
      //  padding: "13px 14px",
    },
    "& .css-nnbavb": {
      display: "none",
    },
  },
});

const Like = (props) => {
  const {
    id,
    id_a,
    label,
    filtrosAAplicar,
    setFiltrosAAplicar,
    error,
    setError,
  } = props;

  const handleInput = (e) => {
    const { value } = e.target;
    setFiltrosAAplicar((prevState) => {
      return { ...prevState, [id_a]: value };
    });
    setError((e) => {
      return { ...e, [id_a]: false };
    });
  };

  const classes = useStyle();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Ejecutar la función proporcionada por el componente envuelto (WrappedComponent)
      props.handleSubmit(event);
    }
  };

  return (
    <div className="likeComponente">
      <Label
        label={props.nombre}
        opcionales_null={props.opcionales_null}
        permite_null={props.permite_null}
      />
      <TextField
        id={id}
        type="text"
        placeholder={props.placeholder}
        style={{ width: "100%" }}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        defaultValue={props.default}
        label={label}
        value={filtrosAAplicar[id_a] ? filtrosAAplicar[id_a] : ""}
        error={error[id_a]}
        // className={classes.likeComponent}
        variant="standard"
      />
    </div>
  );
};
export default Like;
